function injectStyle (ssrContext) {
  require("!!../../node_modules/.2.1.2@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/.12.2.2@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-46dd337e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/.12.2.2@vue-loader/lib/selector?type=styles&index=0!./upload.vue")
}
var Component = require("!../../node_modules/.12.2.2@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/.12.2.2@vue-loader/lib/selector?type=script&index=0!./upload.vue"),
  /* template */
  require("!!../../node_modules/.12.2.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-46dd337e\",\"hasScoped\":true,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../node_modules/.12.2.2@vue-loader/lib/selector?type=template&index=0!./upload.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-46dd337e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/upload.vue
// module id = 4
// module chunks = 0